import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CurrentLocale } from '../../../i18n/locale/locale';
import { CookiesService } from './cookies.service';
import * as dayjs from 'dayjs';
import * as updateLocale from 'dayjs/plugin/updateLocale';

export enum Langs {
  ru = 'ru',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class LangService {
  lang = CurrentLocale.locale as Langs;

  langCookieName = 'lang';
  servePorts = {
    ru: 4230,
    en: 4231,
  };

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private cookiesService: CookiesService,
    private router: Router,
    private dateAdapter: DateAdapter<Date>,
  ) {
    this.lang = locale as Langs;
    console.log('LOCALE:', locale);
    const savedLang = this.cookiesService.get(this.langCookieName);
    // console.log('Saved lang', savedLang);
    if (!savedLang || savedLang !== this.lang) {
      // this.cookiesService.put(this.langCookieName, this.lang);
    }

    this.dayjsLocaleConfigInit();
  }

  // init() {
  //   dayjs.locale(this.lang);
  // }

  setLang(lang: Langs) {
    const url = this.router.url.startsWith('/') ? this.router.url.slice(1) : this.router.url;
    this.lang = lang;
    this.cookiesService.put(this.langCookieName, lang);
    this.dateAdapter.setLocale(lang);

    if (environment.production) {
      window.location.href = `/${lang}/${url}`;
    } else {
      window.location.href =
        `${window.location.protocol}//${window.location.hostname}:${this.servePorts[lang]}/${url}`;
    }
  }

  getTimePlaceholder() {
    switch (this.lang) {
      case Langs.ru:
        return 'чч:мм';
      default:
        return 'hh:mm'
    }
  }

  getDatePlaceholder() {
    switch (this.lang) {
      case Langs.ru:
        return 'дд.мм.гггг';
      default:
        return 'dd.mm.yyyy'
    }
  }

  private dayjsLocaleConfigInit() {
    dayjs.extend(updateLocale);
    dayjs.updateLocale('en', {
      weekStart: 1
    });
  }
}
